import { Injectable } from "@angular/core";
import { ClienteDTO } from "@DTOS";
import { ModalService } from "@shared/services";
import { ClienteModalComponent } from "../../../layout/clientes/componentes-compartidos/cliente-modal/cliente-modal.component";
import { ClientesUtils } from "../Clientes.utils";

@Injectable({
    providedIn: "root"
})
export class ClientesUtilsImpl implements ClientesUtils {
    constructor(private modalService: ModalService) {}

    public async crearClienteAsync() {
        const refModal = this.modalService.open(ClienteModalComponent, { size: "lg", centered: true });

        return await refModal.result.catch(() => null);
    }

    public async editarClienteAsync(cliente: ClienteDTO) {
        const refModal = this.modalService.open(ClienteModalComponent, { size: "lg", centered: true });
        const instancia: ClienteModalComponent = refModal.componentInstance;

        instancia.cliente = cliente;
        instancia.editando = true;

        return await refModal.result.catch(() => null);
    }
}
